import { useDispatch, useSelector } from "react-redux";
import { toggleShowProjectContextMenu } from "../../redux/actions/showProjectContextMenuAction";
import { useRef, useState } from "react";
import useOutside from "../../hooks/useOutside";
import "./contextMenuComponent.css";
import { findByIdInTreeList } from "../../utils/tree";
import { isNullOrUndefined } from "../../utils/todo-utils";
import { deleteTaskFromFirebase } from "../../redux/actions/TodoManipulation/deleteTaskFromFirebaseAction";
import { duplicateTodo } from "../../redux/actions/TodoManipulation/duplicateTodoAction";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";

const ContextMenu = (props) => {
    const { todoId, type, parent, toggleShowModal, toggleShowDateModal, toggleShowDeleteModal, todo } = props;
    const dispatch = useDispatch();
    const contextMenuRef = useRef();
    const selectedDate = useSelector((state) => state.selectedDate.date);
    const projects = useSelector((state) => state.taskList.data);
    useOutside(contextMenuRef, props.moreButtonRef, null, () =>
        toggleContextMenu()
    );

    const toggleContextMenu = () => {
        dispatch(toggleShowProjectContextMenu());
    };

    function getAllTodos(object) {
        const todos = [];
        function traverse(todo) {
            for (const key in todo) {
                if (Object.prototype.hasOwnProperty.call(todo, key)) {
                    const value = todo[key];

                    if (key === 'id') {
                        if (todo.title) {
                            todos.push({
                                Title: todo.title,
                                Description: (isNullOrUndefined(todo.description)) ? '' : todo.description,
                                VisualSize: todo.visualSize,
                                Color: (isNullOrUndefined(todo.color)) ? '#80C3E9' : todo.color.hexString,
                                Type: todo.type ? todo.type.toString() : '0',
                                Id: todo.id,
                                Id_Ref: todo.$id,
                                Parent: todo.parent ? todo.parent.$ref : '',
                                HasChildren: todo.children ? todo.children.length > 0 ? true : false : false
                            });
                        }
                    }
                    else if (Array.isArray(value)) {
                        value.forEach(traverse);
                    }
                    else if (typeof value === 'object') {
                        traverse(value);
                    }
                }
            }
        }

        traverse(object);
        return todos;
    }

    const DuplicateTodoItem = async (todoId) => {

        const project = findByIdInTreeList(projects, todoId);

        const todos = getAllTodos(project);

        const json = {
            todos: todos
        }

        await dispatch(duplicateTodo(json));
    }

    const isMobile = useIsMobile();

    return (
        <div>
            <ul
                className="todo-context-menu-web gt-context-menu"
                role="menu"
                aria-orientation="vertical"
                ref={contextMenuRef}
            >
                <li className="gt-context-menu__item" role="menuitem">
                    <button
                        onClick={(event) => {
                            toggleShowModal(todoId, event);
                            toggleContextMenu();
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.516 14.516">
                            <use xlinkHref="#globaltasks-svg-edit"></use>
                        </svg>
                        Edit
                    </button>
                </li>
                {(type === 0 || (type === 1 && parent !== null)) && <li className="gt-context-menu__item hide" role="menuitem">
                    <button className="gw-task-hide"
                        onClick={(event) => {
                            event.stopPropagation();
                            toggleShowDateModal("hidden", todo.title, todo);
                            toggleContextMenu();
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 15.274 14.433"
                        >
                            <use xlinkHref="#globaltasks-svg-hide"></use>
                        </svg>
                        Hide
                    </button>
                </li>}
                {(type === 1 && parent === null) && <li className="gt-context-menu__item" role="menuitem">
                    <button
                        onClick={(event) => {
                            event.stopPropagation();
                            DuplicateTodoItem(todoId);
                            toggleContextMenu();
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 15.274 14.433"
                        >
                            <use xlinkHref="#globaltasks-svg-copy"></use>
                        </svg>
                        Duplicate
                    </button>
                </li>}

                <li className="gt-context-menu__item" role="menuitem">
                    <button
                        onClick={(event) => {
                            event.stopPropagation();
                            toggleShowDeleteModal(todo);
                            toggleContextMenu();
                        }}
                        style={{ color: '#D4262A' }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.274 14.433"
                            style={{ color: '#D4262A' }} >
                            <use xlinkHref="#globaltasks-svg-delete"></use>
                        </svg>
                        Delete
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default ContextMenu;
